import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/popular-vehicles.css";

function ApproxDuty() {

  const navigate = useNavigate();

//   const popularModels = [

//     {
//       id: 1,
//       name: "Honda Vezel",
//       category: "SUV",
//       year: "2018-2024",
//       image: "🚙",
//       description: "Popular hybrid compact SUV with premium design"
//     },

//     {
//       id: 2,
//       name: "Toyota Raize",
//       category: "SUV",
//       year: "2020-2024",
//       image: "🚗",
//       description: "Compact SUV with sporty styling and fuel efficiency"
//     },

//     {
//       id: 3,
//       name: "Toyota Yaris",
//       category: "Sedan",
//       year: "2017-2024",
//       image: "🚘",
//       description: "Reliable compact sedan with low fuel consumption"
//     },

//     {
//       id: 4,
//       name: "Toyota Yaris Cross",
//       category: "Hybrid",
//       year: "2021-2024",
//       image: "🚙",
//       description: "Modern hybrid crossover with advanced safety"
//     },

//     {
//       id: 5,
//       name: "Toyota Land Cruiser 250",
//       category: "SUV",
//       year: "2024",
//       image: "🚜",
//       description: "Luxury off-road SUV with powerful performance"
//     },

//     {
//       id: 6,
//       name: "Toyota Land Cruiser 300",
//       category: "SUV",
//       year: "2022-2024",
//       image: "🚙",
//       description: "Flagship luxury SUV with advanced technology"
//     },

//     {
//       id: 7,
//       name: "Toyota Roomy",
//       category: "Mini Van",
//       year: "2018-2024",
//       image: "🚐",
//       description: "Compact family mini van with spacious interior"
//     },

//     {
//       id: 8,
//       name: "Toyota Harrier",
//       category: "SUV",
//       year: "2017-2024",
//       image: "🚘",
//       description: "Premium crossover SUV with elegant styling"
//     },

//     {
//       id: 9,
//       name: "Toyota Corolla Cross",
//       category: "Hybrid",
//       year: "2021-2024",
//       image: "🚙",
//       description: "Stylish hybrid crossover with practical features"
//     },

//     {
//       id: 10,
//       name: "Daihatsu Taft",
//       category: "Mini SUV",
//       year: "2020-2024",
//       image: "🚗",
//       description: "Compact kei SUV with rugged appearance"
//     },

//     {
//       id: 11,
//       name: "Daihatsu Rocky",
//       category: "SUV",
//       year: "2019-2024",
//       image: "🚙",
//       description: "Compact SUV with excellent fuel economy"
//     },

//     {
//       id: 12,
//       name: "Suzuki WagonR",
//       category: "Mini Car",
//       year: "2015-2024",
//       image: "🚗",
//       description: "Highly popular kei car with spacious cabin"
//     },

//     {
//       id: 13,
//       name: "Suzuki Spacia",
//       category: "Mini Van",
//       year: "2018-2024",
//       image: "🚐",
//       description: "Compact mini van perfect for city driving"
//     },

//     {
//       id: 14,
//       name: "Suzuki Every",
//       category: "Van",
//       year: "2016-2024",
//       image: "🚚",
//       description: "Reliable commercial and passenger mini van"
//     }

//   ];

//   const [selectedCategory, setSelectedCategory] = useState("All");

//   const categories = [
//     "All",
//     "SUV",
//     "Sedan",
//     "Hybrid",
//     "Mini Van",
//     "Mini SUV",
//     "Mini Car",
//     "Van"
//   ];

//   const filteredModels =
//     selectedCategory === "All"
//       ? popularModels
//       : popularModels.filter(
//           (model) => model.category === selectedCategory
//         );

  return (

    <div className="popular-vehicles-page">

      {/* HEADER */}
      <div className="pv-header">

        <button
          className="pv-back-btn"
          onClick={() => navigate(-1)}
        >
          ← Back
        </button>

        <h1>Approximate Duty Calculator</h1>

        <p>
          Calculate the approximate duty for imported vehicles in Sri Lanka
        </p>

      </div>

      {/* FILTERS */}
      {/* <div className="pv-filter-section">

        <div className="pv-filters">

          {categories.map((category) => (

            <button
              key={category}
              className={`pv-filter-btn ${
                selectedCategory === category ? "active" : ""
              }`}
              onClick={() => setSelectedCategory(category)}
            >
              {category}
            </button>

          ))}

        </div>

      </div> */}

      {/* VEHICLE GRID */}
      {/* <div className="pv-gallery-container">

        <div className="pv-gallery-grid">

          {filteredModels.map((model) => (

            <div key={model.id} className="pv-model-card">

              <div className="pv-card-emoji">
                {model.image}
              </div>

              <div className="pv-card-content">

                <h3>{model.name}</h3>

                <p className="pv-card-category">
                  {model.category}
                </p>

                <p className="pv-card-year">
                  Model Years: {model.year}
                </p>

                <p className="pv-card-description">
                  {model.description}
                </p>

              </div>

            </div>

          ))}

        </div>

      </div> */}

      {/* RESULTS */}
      {/* <div className="pv-results-info">

        <p>
          Showing <strong>{filteredModels.length}</strong> of{" "}
          <strong>{popularModels.length}</strong> vehicle models
        </p>

      </div> */}

    </div>

  );

}

export default ApproxDuty;